import { useEffect, useState } from "react";
import { getSupabase } from "../lib/supabase";
export default function ContactsAdmin() {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let isMounted = true;

    async function fetchContacts() {
      setLoading(true);
      setError("");
      const supabase = await getSupabase();

      const { data, error } = await supabase
        .schema("api")
        .from("contact_submissions")
        .select("id, name, email, message, created_at")
        .order("created_at", { ascending: false });

      if (!isMounted) return;

      if (error) {
        console.error(error);
        setError("Failed to load contact submissions.");
      } else {
        setContacts(data || []);
      }

      setLoading(false);
    }

    fetchContacts();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div className="space-y-10">
      {/* HEADER */}
      <div>
        <h1 className="text-3xl font-semibold tracking-tight">
          Contact Submissions
        </h1>
        <p className="mt-1 text-sm text-slate-500">
          Messages submitted via the website contact form.
        </p>
      </div>

      {/* ERROR */}
      {error && <p className="text-sm text-red-600">{error}</p>}

      {/* TABLE / SKELETON */}
      <div className="overflow-x-auto rounded-2xl border border-white/20 bg-white/70 shadow-xl backdrop-blur-xl dark:bg-white/5">
        <table className="min-w-full">
          <thead className="bg-slate-100/70 dark:bg-white/10">
            <tr>
              <th className="px-4 py-3 text-left text-sm font-medium">Name</th>
              <th className="px-4 py-3 text-left text-sm font-medium">Email</th>
              <th className="px-4 py-3 text-left text-sm font-medium">
                Message
              </th>
              <th className="px-4 py-3 text-left text-sm font-medium">Date</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              [...Array(5)].map((_, i) => <SkeletonRow key={i} />)
            ) : contacts.length === 0 ? (
              <tr>
                <td
                  colSpan={4}
                  className="px-4 py-6 text-center text-sm text-slate-500"
                >
                  No contact submissions yet.
                </td>
              </tr>
            ) : (
              contacts.map((c) => (
                <tr
                  key={c.id}
                  className="border-t border-slate-200/60 dark:border-white/10"
                >
                  <td className="px-4 py-3 text-sm">{c.name}</td>
                  <td className="px-4 py-3 text-sm">{c.email}</td>
                  <td className="max-w-md truncate px-4 py-3 text-sm">
                    {c.message}
                  </td>
                  <td className="px-4 py-3 text-sm whitespace-nowrap">
                    {new Date(c.created_at).toLocaleString()}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

/* ================= SKELETON ================= */

function SkeletonRow() {
  return (
    <tr className="animate-pulse border-t border-slate-200/60 dark:border-white/10">
      <td className="px-4 py-3">
        <div className="h-4 w-24 rounded bg-slate-300/60 dark:bg-white/10" />
      </td>
      <td className="px-4 py-3">
        <div className="h-4 w-40 rounded bg-slate-300/50 dark:bg-white/10" />
      </td>
      <td className="px-4 py-3">
        <div className="h-4 w-full rounded bg-slate-300/40 dark:bg-white/10" />
      </td>
      <td className="px-4 py-3">
        <div className="h-4 w-32 rounded bg-slate-300/40 dark:bg-white/10" />
      </td>
    </tr>
  );
}
